import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { WORKFLOW_STEP } from '../../constants/Urls';
import { useFormSelector } from '../../custom-hooks';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../utils/commonUtils';
import DynamicField from '../DynamicField';
import { getAllButtons } from '../selectors/form-manager.selectors';
import { getFormFooterWidthPercentBasedOnSelectedSubGrids } from '../selectors/runtime.selectors';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    height: 64,
    width: ({ widthPercent }) => `${widthPercent}%`,
    borderTop: 'solid 1px #e9e9e9',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 32,
    '& button': {
      marginRight: 16,
      minWidth: ({ buttonMinWidth }) => `${buttonMinWidth}px !important`,
    },
    '& span[ui-ta="FormCtrl SSButton Cancel"]': {
      order: 1,
    },
    '& span': {
      order: 2,
    },
    '& span[ui-ta="FormCtrl SSButton Save"]': {
      order: 3,
    },
    '& span[ui-ta="FormCtrl SSButton SaveOffline"]': {
      order: 4,
    },
  },
  fixedContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 10,
    paddingLeft: 0,
    overflowX: 'scroll',
    flexDirection: 'row-reverse',
  },
  buttonsContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

const FormFooter = ({ isEditor }) => {
  const { pathname } = useLocation();
  const { isMobileDevice } = useWindowDimensions();
  const formButtons = useFormSelector(getAllButtons);
  const widthPercent = useFormSelector(getFormFooterWidthPercentBasedOnSelectedSubGrids, {
    pathname,
    isMobileDevice,
  });
  const classes = useStyles({
    widthPercent,
    buttonMinWidth: isMobileDevice && formButtons.length > 2 ? 98 : 128,
  });
  const shouldBeFixed = isMobileDevice && ![WORKFLOW_STEP, WORKFLOW_STEP].includes(pathname);

  return (
    !isEditor && (
      <div
        ui-ta={getUITA('form-buttons')}
        className={classNames(classes.root, shouldBeFixed ? classes.fixedContainer : '')}
      >
        <div className={classes.buttonsContainer}>
          {formButtons && formButtons.map((key) => <DynamicField forceRender key={key} id={key} />)}
        </div>
      </div>
    )
  );
};

export default FormFooter;
